import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";
import CustomTable from './CustomTable'
import { TenantBizFieldServiceProxy,TenantCustomBizFieldUpdateDTO,TenantBizDataTypeDTO,TenantBizInitFieldDTO } from '@/service-proxies/app-v2/system.service-proxies'
import { DictServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import './bill.less'
import { nextTick } from '@vue/composition-api';
const dictService = new DictServiceProxy()
const tenantBizField = new TenantBizFieldServiceProxy()

@Component({
  name: 'bill-plan',
  components: {
    CustomTable
  }
})
export default class Simple extends Vue {
  @Prop() bizCode: string
  @Prop() dataId: string = ''
  @Prop() dataName: string = ''
  @Ref() customTable : CustomTable
  @Watch('bizCode',{immediate: true})
  @Watch('dataId',{immediate: true})
  loadTable() {
    if(this.dataId !== '' && this.dataId !== undefined){
      this.customTable.getData(this.bizCode,this.dataId)
    }
  }

  bizCodeList = []
  fieldTypes = []
  loading = false
  isShow = true

  save() {
    this.customTable.save()
  }

  reloadSettings() { // 还原默认配置
    const ok: any = this.$t('ok')
    const cancel: any = this.$t('cancel')
    this.$confirm({
      title: this.$t('page_bill_settings_resetdefault'),
      content: this.$t('page_bill_settings_to_resetdefault'),
      okText: ok,
      okType: 'danger',
      cancelText: cancel,
      onOk: () => {
        this.reset()
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  reset(){
    tenantBizField.resetTenantCustomBizField(this.bizCode,this.dataId,this.dataName).then(res => {
      this.customTable.getData(this.bizCode,this.dataId)
      this.$message.success(this.$t('page_user_management_reset_successful'))
    })
  }
  isEdit(){
    this.$emit('edit')
  }
  closeEdit(){
    this.$emit('closeEdit')
  }
  contentShow(){
    this.isShow = !this.isShow
  }
  render() {
    return (
      <div class="table-content">
        <div class="title">
          <div></div>
          <div>
            <a-button
              v-acl="page_bill_settings_save"
              type="primary"
              disabled={this.dataId == '' || this.dataId == undefined}
              onClick={() => this.save()}
            >
              {this.$t('save')}
            </a-button>
            <a-button
              v-acl="page_bill_settings_reset"
              type="danger"
              disabled={this.dataId == '' || this.dataId == undefined}
              style="margin-left: 8px;"
              onClick={() => this.reloadSettings()}
            >
              {this.$t('page_bill_settings_resetdefault')}
            </a-button>
            <a-button
              type="link"
              style="margin-left: 8px;"
              onClick={() => this.contentShow()}
            >
              <a-icon style="transition: width 2s;" type={this.isShow ? 'right' : 'down'} />
            </a-button>
          </div>
        </div>
        <div class="table-content-custom" style={{display: this.isShow ? 'block': 'none'}}>
          <custom-table ref="customTable" scrollY={350} onEdit={() =>{this.isEdit()}} onCloseEdit={() =>{this.closeEdit()}}></custom-table>
        </div>
      </div>
    )
  }
}